import script from "./NTableSection.vue?vue&type=script&lang=ts"
export * from "./NTableSection.vue?vue&type=script&lang=ts"

import "./NTableSection.vue?vue&type=style&index=0&id=1ac6d4b8&lang=stylus"

const __exports__ = script;

export default __exports__